// extracted by mini-css-extract-plugin
export default {"mdrSelect":"Select_mdrSelect__v71tS"};